<template>
  <th :class="{center}" :style="setStyle()">
    <div class="sort" :style="{cursor: sortValue ? 'pointer' : 'default'}" :dir="uiDirection">
      <i class="ri-add-large-fill showHide" :dir="uiDirection" v-if="(sortValue === 'symbol' || allowActionsHiding) && !showSymbolActions"
         @click="$emit('toggleSymbolActions')"/>
      <i class="ri-subtract-fill showHide" :dir="uiDirection" v-if="(sortValue === 'symbol' || allowActionsHiding) && showSymbolActions"
         @click="$emit('toggleSymbolActions')"/>

      <div @click="$emit('sort')" class="clickable">
        <slot/>
        <i class="ri-arrow-down-s-line sortSign" :class="{active: sortKey === sortValue}"
           v-if="sortDirection === -1 && sortValue === sortKey"/>
        <i class="ri-arrow-up-s-line sortSign" :class="{active: sortKey === sortValue}"
           v-if="sortDirection === 1 && sortValue === sortKey"/>
      </div>

      <Popper
          arrow
          :hover="true"
          :content="tooltip || header.info"
          v-if="tooltip || header.info"
      >
        <div class="tooltipIcon">
          <i class="ri-information-line"/>
        </div>
      </Popper>
    </div>



  </th>
</template>

<script>


import Popper from "vue3-popper";

export default {
  name: "HeadCell",
  props: ['sortKey', 'sortDirection', 'sortValue', 'header', 'center', 'width', 'tooltip', 'small', 'showSymbolActions', 'allowActionsHiding'],
  components: {Popper},
  methods: {
    setStyle() {
      return this.width ? {width: `${this.width}px`, overflow: 'hidden'} : {};
    }
  }
}
</script>


<style scoped lang="scss">

@import "../../assets/style/general";

th {
  user-select: none;
  border-bottom: 2px solid var(--notficationBorderColor);
  background: var(--bgColor) !important;
  font-size: 15px;
  font-weight: 600;
}

.center {
  text-align: center !important;
}

.clickable {
  box-sizing: border-box;
  flex: 1 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  cursor: pointer;
}

.sort {
  padding: 1.5px 7px;
  width: 100%;
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  gap: 10px;
}

.sortSign {
  color: #aaa;
  opacity: .3;
}

.active {
  color: var(--activeSortSignColor);
  opacity: 1;
}

.showHide {
  padding: 10px;
  margin: -5px 0 -5px -10px;
  z-index: 2;
  background: var(--highlightColorOpacity);

  &[dir="rtl"] {
    margin: -5px -10px -5px 0;
  }
}
</style>
